
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

/* -- GLOBAL IMPORTS --- */
import collapsible from "./components/global/collapsible";
import dropdown from "./components/global/dropdown";
import mobileNav from "./components/global/mobile-nav.js";
import mouseOrKeyboardDetect from "./components/global/mouse-or-keyboard-detect.js";
import siteSearch from "./components/global/site-search.js";
import alerts from "./components/global/alerts.js";
import livechat from "./components/global/livechat";
import cookieWarning from "./components/global/cookie-warning";
import desktopNav from "./components/global/desktop-nav";

/* -- COMPONENT IMPORTS --- */
import brandSlider from "./components/brand-slider.js";
import heroSlider from "./components/hero-slider.js";
import promoSlider from "./components/promo-slider.js";
import quantityControl from "./components/quanitity-control.js";
import assessment from "./components/assessment";
import forms from "./forms/global.js";
import animatedCounter from "./components/animated-counter";
import 'lazysizes';

/* -- FORM IMPORTS--- */
import contact from "./forms/contact.js";
// import editAccount from "./forms/edit-account.js";
import editPassword from "./forms/edit-password.js";
import giftCode from "./forms/gift-code.js";
import couponCode from "./forms/coupon-code.js";
import payment from "./forms/payment.js";
// import registration from "./forms/registration.js";
import competition from "./forms/competition.js";
import datePicker from "./forms/date-picker";
import productDisclaimer from "./components/product-disclaimer.js";
import donationForm from "./components/donation-form.js";


window.walletDocPublicKey = process.env.MIX_WALLETDOC_PUBLIC_KEY;

/* -- GLOBAL INITIALISE --- */
alerts.init();
collapsible.initCollapsible();
dropdown.initDropdown();
mobileNav.initMobileNav();
mouseOrKeyboardDetect.init();
siteSearch.init();
forms.init();
// livechat.init();
cookieWarning.init();
desktopNav.init();

/* -- COMPONENT INITIALISE --- */
// Assessment
if (document.querySelector('.js-assessment')) {
    assessment.init();
}

// Brand Slider
if (document.querySelector('.js-brand-slider')) {
    brandSlider.initSlider();
}

// Hero Slider
if (document.querySelector('.js-hero-slider')) {
    heroSlider.initSlider();
}

// Promo Slider
if (document.querySelector('.js-promo-slider')) {
    promoSlider.initSlider();
}

// Quantity Input
if (document.querySelector('.js-quantity-control')) {
    quantityControl.init();
}

/* -- FORM INITIALISE --- */

// Contact
if (document.querySelector('.js-contact-form')) {
    contact.init();
}

//Competition entry
if (document.querySelector('.js-competition-form')) {
    competition.init();
}

// Edit Account
/*
if (document.querySelector('.js-edit-account-form')) {
    editAccount.init();
}
*/

// Edit Password
if (document.querySelector('.js-edit-password-form')) {
    editPassword.init();
}

// Gift Code
if (document.querySelector('.js-gift-code-form')) {
    giftCode.init();
}

//Coupon code
if (document.querySelector('.js-coupon-code-form')) {
    couponCode.init();
}

// Payment
if (document.querySelector('.js-payment-form')) {
	payment.init();
}

// Registration
// if (document.querySelector('.js-registration-form')) {
// 	registration.init();
// }

// Custom date picker
if (document.querySelector('.js-datetimepicker')) {
	datePicker.init();
}

// Animated counter
if (document.querySelector('.js-animated-counter')) {
	animatedCounter.init();
}

// Product disclaimer
if (document.querySelector('.js-product-disclaimer')) {
	productDisclaimer.init();
}

//Donation form submission
if (document.querySelector('.js-donation-form')) {
	donationForm.init();
}